import * as React from "react";
import { Input } from "antd";

class EditableTableCell extends React.Component {
	state = {
		editing: false,
	};

	toggleEdit = () => {
		const editing = !this.state.editing;
		this.setState({ editing }, () => {
			if (editing) {
				this.input.focus();
			}
		});
	};

	save = (e) => {
		const { recordId, handleSave } = this.props;
		const value = e.currentTarget.value;

		this.toggleEdit();
		handleSave(recordId, value);
	};

	render() {
		const { value } = this.props;
		const { editing } = this.state;

		return editing ? (
			<Input
				ref={(node) => (this.input = node)}
				onPressEnter={this.save}
				onBlur={this.save}
				defaultValue={value || null}
			/>
		) : (
			<div
				className="editable-cell-value-wrap"
				style={{ paddingRight: 24, cursor: "pointer" }}
				onClick={this.toggleEdit}
			>
				{value || "Click to edit"}
			</div>
		);
	}
}

export default EditableTableCell;
